// 共通メソッド
export default {
  methods: {

    //改行処理
    nl2br: function(str){
      return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br/>')
    },

    // メールアドレスのバリデーション
    validateEmail: function(email)
    {
      var regx = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return regx.test(email)
    },

    // デバイスIDのスペースを削除
    trimDeviceId: function(nfc_uid)
    {
      return nfc_uid.replace(/\s/g,"")
    },

    // 金額3桁区切り
    separatePrice: function(price)
    {
      return String(price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },

    // 重複するイベント名/グループ名が存在するか確認
    hasDupName: function(objs, name) {
      const dupNameObjs = objs.filter(function(obj) {
        return obj.name === name;
      })
      return 0 < dupNameObjs.length;
    },

    setPageTitle: function(title = null) {
      const defaultTitle = 'CUONA MANAGER';
      document.title = title ? `${title} - ${defaultTitle}` : defaultTitle;
    },
  }
}
